<section class="no-auth-page">
  <header>
    <h3>Sign up for free</h3>
    <h4>Connect with your clients no matter the channel</h4>
  </header>

  <signup-form></signup-form>

  <p class="hint-text">
    You have an account?
    <button ht-button-primary appearance="minimal" routerLink="/sign-in"
      >Sign in</button
    >
  </p>
</section>
